import React from 'react';
import LoginForm from './LoginForm';
import FloatingCard from '~components/FloatingCard';

function Login() {
  return (
    <FloatingCard.Centered>
      <LoginForm />
    </FloatingCard.Centered>
  );
}

export default Login;
